module.exports = __webpack_public_path__ + "f1d1c9314b3716818e3a0ef44b067c26.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-18.png
// module id = 2907
// module chunks = 0